export const UsersAllTR={
UserID:{en:'User ID',cs:'',dataType:'number',format:'#0',required:true},
UserLoginName:{en:'Login Name',cs:'',dataType:'string',maxLength:1020},
UserLoginPwd:{en:'UserLoginPwd',cs:'UserLoginPwd',dataType:'string',maxLength:1020},
UserADDoID:{en:'Domain',cs:'',dataType:'number',format:'#0'},
UserADLogin:{en:'UserADLogin',cs:'UserADLogin',dataType:'string',maxLength:256},
UserADGuid:{en:'UserADGuid',cs:'UserADGuid',dataType:'string',maxLength:1020},
UserFirstName:{en:'UserFirstName',cs:'UserFirstName',dataType:'string',maxLength:1020},
UserSurname:{en:'UserSurname',cs:'UserSurname',dataType:'string',maxLength:1020},
UserFullName:{en:'Full Name',cs:'',dataType:'string',maxLength:1020},
UserIsActive:{en:'Active',cs:'',dataType:'boolean',required:true},
UserTimeStamp:{en:'UserTimeStamp',cs:'UserTimeStamp',dataType:'number',format:'#0'},
UserEmail:{en:'Email Address',cs:'',dataType:'string',maxLength:1020},
UserADLoID:{en:'Location',cs:'',dataType:'number',format:'#0'},
ADDoDomainName:{en:'Domain',cs:'',dataType:'string',maxLength:100},
ADLoLocationName:{en:'Location',cs:'',dataType:'string',maxLength:100},
UserTelephone:{en:'Phone',cs:'Telefon',dataType:'string',maxLength:20},
UserLanguageLCID:{en:'Language',cs:'Jazyk',dataType:'number',format:'#0'}
}